import { Header } from "../../components/Header";
import qrScannerImage from "../../assets/images/qr-scanner.png";
import verifyIdentityImage from "../../assets/images/verify-identity.png";
import clockImage from "../../assets/images/clock.png";
import "./Onboarding.scss";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { CHOOSE_SUPERVISOR_TYPE } from "../../constants/routes";
import * as storageUtils from "../../utils/localStorage";
import {
  CONTINUE_BUTTON,
  ONBOARDING_STEP_ONE_MESSAGE,
  ONBOARDING_STEP_THREE_MESSAGE,
  ONBOARDING_STEP_TWO_MESSAGE,
} from "../../constants/translationKeys";
import translationsStore from "../../stores/TranslationsStore";
import { observer } from "mobx-react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import SizedBox from "../../components/SizedBox/SizedBox";

const OnboardingPage = () => {
  const history = useHistory();
  const { translations } = translationsStore;
  const [currentStep, setCurrentStep] = useState(1);
  const [swiper, setSwiper] = useState(null as any);
  const buildStepOne = () => {
    return buildStep({
      imageUri: qrScannerImage,
      text: translations[ONBOARDING_STEP_ONE_MESSAGE],
      onClick: () => {
        setCurrentStep(2);
      },
      stepIndicator: 1,
    });
  };

  const buildStepTwo = () => {
    return buildStep({
      imageUri: verifyIdentityImage,
      text: translations[ONBOARDING_STEP_TWO_MESSAGE],
      onClick: () => {
        setCurrentStep(3);
      },
      stepIndicator: 2,
    });
  };

  const buildStepThree = () => {
    return buildStep({
      imageUri: clockImage,
      text: translations[ONBOARDING_STEP_THREE_MESSAGE],
      onClick: () => {
        history.replace(CHOOSE_SUPERVISOR_TYPE);
        storageUtils.setFirstVisitFlag();
      },
      stepIndicator: 3,
    });
  };

  const buildStep = ({
    imageUri,
    text,
    onClick,
    stepIndicator,
  }: {
    imageUri: string;
    text: string;
    onClick(): void;
    stepIndicator: 1 | 2 | 3;
  }) => {
    return (
      <>
        <div className="image-text-container">
          <div className="image-wrapper">
            <img className="onboarding-image" src={imageUri} alt="Missing." />
          </div>
          <SizedBox height={20} />
          <p className="onboarding-text">{text}</p>
        </div>
      </>
    );
  };

  const switchSlide = (slide: number) => {
    setCurrentStep(slide);
    swiper.slideTo(slide - 1);
  };

  const nextSlide = () => {
    if (currentStep !== 3) {
      switchSlide(currentStep + 1);
    } else {
      history.replace(CHOOSE_SUPERVISOR_TYPE);
      storageUtils.setFirstVisitFlag();
    }
  };

  return (
    <div className="layout-column flex">
      <Header />
      <div className="onboarding-container flex">
        <h1>Supervisor App</h1>
        <div className="swiperWrap">
          <Swiper 
            spaceBetween={10} 
            slidesPerView={1} 
            onSwiper={(swiper: any) => setSwiper(swiper)}
            onSlideChange={(a) => setCurrentStep(a.activeIndex + 1)}
            >
            <SwiperSlide>{buildStepOne()}</SwiperSlide>
            <SwiperSlide>{buildStepTwo()}</SwiperSlide>
            <SwiperSlide>{buildStepThree()}</SwiperSlide>
          </Swiper>
        </div>

        <div className="dots-container">
          <div
            onClick={() => {
              switchSlide(1);
            }}
            className={`onboarding-dot left-dot ${
              currentStep === 1 ? "active" : ""
            }`}
          ></div>
          <div
            onClick={() => {
              switchSlide(2);
            }}
            className={`onboarding-dot middle-dot ${
              currentStep === 2 ? "active" : ""
            }`}
          ></div>
          <div
            onClick={() => {
              switchSlide(3);
            }}
            className={`onboarding-dot right-dot ${
              currentStep === 3 ? "active" : ""
            }`}
          ></div>
        </div>

        <div className="spacer"></div>

        <button
          className="button filled-button onboarding-continue-button"
          onClick={() => nextSlide()}
        >
          {translations[CONTINUE_BUTTON]}
        </button>
      </div>
    </div>
  );
};

export default observer(OnboardingPage);
